import { compact } from "lodash";
import { useDocumentTitle } from "usehooks-ts";

/** useDocumentTitle formatted for use in the learner app */
export function useLearnerDocumentTitle(title: string | undefined) {
  useDocumentTitle(compact([title, "DeltaMath for Home"]).join(" | "));
}
